import { useEffect, useState } from 'react';

import { useLazyGetCourtBookingQuery } from '../store/Api';
import { CourtBooking } from '../store/types';

interface Props {
  bookingIds: number[] | null;
}

export function useGetBookingDetail({ bookingIds }: Props) {
  const [courtBookingDetail, setCourtBookingDetail] = useState<CourtBooking>();
  const [getBookedCourtInfo, { data: dataCourtBookingDetail, isLoading: isBookingLoading }] = useLazyGetCourtBookingQuery();

  useEffect(() => {
    if (bookingIds !== null) {
      (async () => {
        for (const bookingid of bookingIds) {
          await getBookedCourtInfo(bookingid);
        }
      })();
    }
  }, [bookingIds, getBookedCourtInfo]);

  useEffect(() => {
    if (dataCourtBookingDetail === undefined) {
      return;
    }

    setCourtBookingDetail((current) => {
      if (!current) {
        return dataCourtBookingDetail;
      }

      if (!current.userIds.includes(dataCourtBookingDetail.userIds[0])) {
        return {
          ...dataCourtBookingDetail,
          groupBookingId: dataCourtBookingDetail.groupBookingId ?? current.groupBookingId,
          userNames: [...current.userNames, ...dataCourtBookingDetail.userNames],
          coachBookingIds: [...current.coachBookingIds, ...dataCourtBookingDetail.coachBookingIds],
          coachNames: [...current.coachNames, ...dataCourtBookingDetail.coachNames],
          userIds: [...current.userIds, ...dataCourtBookingDetail.userIds],
          priceDetails: [...current.priceDetails, ...dataCourtBookingDetail.priceDetails],
          price: [...current.price, ...dataCourtBookingDetail.price],
          usersHasDeposite: [...current.usersHasDeposite, ...dataCourtBookingDetail.usersHasDeposite],
        };
      }

      return {
        ...current,
        groupBookingId: dataCourtBookingDetail.groupBookingId ?? current.groupBookingId,
        confirmed: dataCourtBookingDetail.confirmed,
        courtId: dataCourtBookingDetail.courtId,
        note: dataCourtBookingDetail.note
      };
    });
  }, [dataCourtBookingDetail]);
  return ({
    courtBookingDetail,
    isBookingLoading
  });
}

